import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/kingsville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Kingsville, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Kingsville & Kleberg County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Kingsville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Kingsville and Kleberg County.",
      keywords: "awnings Kingsville, awning company Kingsville, custom awnings Kingsville, sail shades Kingsville, patio covers Kingsville, pergola covers Kingsville, metal awnings Kingsville, canvas awnings Kingsville, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Kingsville", "Kleberg County"),
  }),
  component: () => <CityHomePage city="Kingsville" region="Kleberg County" />,
});
